export default "__VITE_ASSET__DCAT043k__"